import React from "react";
import WorkTimeContainer from "../containers/WorkTime";

const WorkTime = () => {
  return <WorkTimeContainer />;
};

export default WorkTime;
